import { render, staticRenderFns } from "./SeriesList.vue?vue&type=template&id=6a1c4d7b&scoped=true&"
import script from "./SeriesList.vue?vue&type=script&lang=js&"
export * from "./SeriesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a1c4d7b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6a1c4d7b')) {
      api.createRecord('6a1c4d7b', component.options)
    } else {
      api.reload('6a1c4d7b', component.options)
    }
    module.hot.accept("./SeriesList.vue?vue&type=template&id=6a1c4d7b&scoped=true&", function () {
      api.rerender('6a1c4d7b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/vue/components/Series/SeriesList.vue"
export default component.exports